import { render, staticRenderFns } from "./WeatherStatement.vue?vue&type=template&id=5d68fc2c&"
import script from "./WeatherStatement.vue?vue&type=script&lang=js&"
export * from "./WeatherStatement.vue?vue&type=script&lang=js&"
import style0 from "./WeatherStatement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports